import { reactive, toRef, effectScope } from 'vue'

const storeRegistry = new Map()

export function createPinia() {
  return {
    install() {
      // 轻量实现：当前项目只需要 defineStore 的单例能力
    }
  }
}

export function defineStore(id, setup) {
  return function useStore() {
    if (!storeRegistry.has(id)) {
      // Stores outlive the component that first creates them (e.g. login redirects).
      // Keep their watchers alive when that component is unmounted.
      const scope = effectScope(true)
      const rawStore = scope.run(setup)
      const wrappedStore = reactive(rawStore)
      storeRegistry.set(id, wrappedStore)
    }
    return storeRegistry.get(id)
  }
}

export function storeToRefs(store) {
  const out = {}
  for (const key in store) {
    if (typeof store[key] === 'function') continue
    out[key] = toRef(store, key)
  }
  return out
}
